export default {
    dynamicPriceAPI: 'https://pricingapi.oneshotparking.ca/api',
    // dynamicPriceAPI: 'http://localhost:5175/api',
    WeatherEndPoint: '/Weather/Weather',
    apiKey : 'b8f81093-a9ff-4338-bd1c-1201cc1ce2e7'
}
  